import React, { MouseEventHandler, ReactElement, useCallback, useContext } from 'react'
import LineInfoCircleIcon from 'LuxKit/Icons/line/LineInfoCircleIcon'
import Clickable from 'components/Common/Clickable'
import { searchResultPolicyClick } from 'analytics/eventDefinitions'
import { addGTMEvent } from 'api/googleTagManager'
import BedbankCancellationPolicyModal from './BedbankCancellationPolicyModal'
import BedbankPropertyCancellationPoliciesBase from 'components/Common/CancellationPolicies/Bedbank/BedbankPropertyCancellationPoliciesBase'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import ModalContext from 'contexts/ModalContext'
import { BedbankCancellationPolicyWithInfo } from '../../../lib/search/hotels'
import InlineIcon from 'components/utils/InlineIcon'

interface Props {
  rate: App.BedbankRate | App.OrderBedbankRate | BedbankCancellationPolicyWithInfo;
  showNonCancellation: boolean;
  isConfirmation?: boolean;
  showHotelOnly?: boolean;
  icon?: ReactElement;
}

function BedbankCancellationPolicy({
  rate,
  isConfirmation,
  showNonCancellation,
  showHotelOnly = true,
  icon,
}: Props) {
  const showModal = useContext(ModalContext)
  const openModal = useCallback<MouseEventHandler<HTMLButtonElement>>((event) => {
    event.preventDefault()
    addGTMEvent(searchResultPolicyClick())
    const modalHeading = rate.partiallyRefundable ? 'Partially refundable' :
      rate.refundable ? 'Free cancellation' :
        'Non-refundable and no date changes permitted'

    showModal(<BedbankCancellationPolicyModal
      heading={modalHeading}
      policyDescriptions={rate.cancellationPolicy.description ?? []}
    />)
  }, [rate, showModal])

  const shouldShowCancellationPolicy = rate.partiallyRefundable || (rate.refundable && !isConfirmation) || (!rate.partiallyRefundable && !rate.refundable && showNonCancellation)

  if (!shouldShowCancellationPolicy) return null

  return <Clickable onClick={openModal}>
    {rate.partiallyRefundable && <BodyTextBlock variant="medium" startIcon={icon}>
      Partially refundable <InlineIcon Icon={LineInfoCircleIcon} />
    </BodyTextBlock>}
    {rate.refundable && !isConfirmation && <BedbankPropertyCancellationPoliciesBase icon={icon} cancellationPolicy={rate.cancellationPolicy} showHotelOnly={showHotelOnly} />}
    {!rate.partiallyRefundable && !rate.refundable && showNonCancellation && <BodyTextBlock variant="medium" startIcon={icon}>
      Non-refundable <InlineIcon Icon={LineInfoCircleIcon} />
    </BodyTextBlock>}
  </Clickable>
}

export default BedbankCancellationPolicy
